import * as ActionsTypes from "../../../../common/constants/stateConstants";
import {arrayContentElementInitialState, updateState,} from "../../../../common/utils/helpers";

const initialState = {
  historiqueListe: arrayContentElementInitialState,
};

/*-------------------------------------------------CONSULTATION-SOUSCRIPTIONS----------------------------------------------------*/
const getHistorySouscription = (state) => {
  return updateState("historiqueListe", state, {
    ...arrayContentElementInitialState,
    isLoading: true,
  });
};

const getHistorySouscriptionSuccess = (state, payload) => {
  return updateState("historiqueListe", state, {
    content: payload,
    isLoading: false,
    isSuccessed: true,
  });
};

const getHistorySouscriptionFail = (state, payload) => {
  return updateState("historiqueListe", state, {
    error: payload,
    isLoading: false,
    hasError: true,
  });
};

/*************************************************************************** */
const historySouscriptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionsTypes.GET_HISTORY_SOUSCRIPTIONS:
      return getHistorySouscription(state, action);
    case ActionsTypes.GET_HISTORY_SOUSCRIPTIONS_SUCCESS:
      return getHistorySouscriptionSuccess(state, action.payload);
    case ActionsTypes.GET_HISTORY_SOUSCRIPTIONS_FAIL:
      return getHistorySouscriptionFail(state, action.payload);
    default:
      return state;
  }
};

export default historySouscriptionsReducer;
